import React from 'react';
import { ParticipantStep } from '../../../../../../types/v3Types';
import { ButtonNames } from '../../../../../../contexts/main/biInterfaces';
import { classes } from '../SidebarLayoutForParticipant.st.css';
import { StartButton } from './StartButton';
import { Props } from '../interfaces';
import { TextButton } from '@wix/wix-ui-tpa/cssVars';
import { SparklesFilled } from '@wix/wix-ui-icons-common';
import { useSidebarLayoutBase } from '../contexts/SidebarLayoutBase/SidebarLayoutBaseContext';
import { useSettings } from '@wix/tpa-settings/react';
import challengeSettings from '../../../../settingsParams';

export interface SidebarStartButtonProps {
  props: Props;
  isProgramFinished: boolean;
  getIsStartDisabled: () => boolean;
  setStep: (currentStep: ParticipantStep) => void;
  sendBiButtonClick: (buttonName: ButtonNames, step?: string) => void;
}

export const SidebarStartButton: React.FC<SidebarStartButtonProps> = ({
  props,
  isProgramFinished,
  getIsStartDisabled,
  setStep,
  sendBiButtonClick,
}) => {
  const settings = useSettings();
  const { toggleAiChatVisibility, isAiChatEnabled } = useSidebarLayoutBase();
  const title = settings.get(challengeSettings.aiTitleTxt);

  if (!props.isMobile || isProgramFinished) {
    return null;
  }

  return (
    <div className={classes.startButton}>
      <StartButton
        props={props}
        getIsStartDisabled={getIsStartDisabled}
        setStep={setStep}
        sendBiButtonClick={sendBiButtonClick}
      />
      {isAiChatEnabled && (
        <div className={classes.mobileAIChatButtonContainer}>
          <TextButton
            onClick={toggleAiChatVisibility}
            prefixIcon={<SparklesFilled />}
          >
            {title as string}
          </TextButton>
        </div>
      )}
    </div>
  );
};
